/**
 * Новости — контракт ручек (схемы `News`, `NewsInput`, `PublicNews` в
 * `openapi.yaml`, пока только на staging). Бэкенд сделан по этим типам и
 * docs/notes/news-contract.md; HTML текста сервер чистит от скриптов.
 *
 *   GET    /api/v1/news?page=&page_size=      — опубликованные, новые сверху: { items, total }
 *   GET    /api/v1/news/{id}                  — одна опубликованная, с текстом
 *   GET    /api/v1/admin/news?page=&page_size=&q= — все (perm news:r): { items, total }
 *   POST   /api/v1/admin/news                 — создать (perm news:c)
 *   GET    /api/v1/admin/news/{id}            — одна (perm news:r)
 *   PUT    /api/v1/admin/news/{id}            — сохранить целиком (perm news:u)
 *   DELETE /api/v1/admin/news/{id}            — удалить (perm news:d)
 *   POST   /api/v1/admin/news/media           — загрузить фото → { key, url } (perm news:u)
 */

export interface NewsDto {
  id: number
  title_ru: string
  title_uz: string
  /** Анонс для карточки на главной и в списке — простой текст. */
  lead_ru: string
  lead_uz: string
  /** Текст новости — HTML редактора админки; приложение показывает его очищенным. */
  body_ru: string
  body_uz: string
  /** Фото: ключ из `POST /admin/news/media` (для записи) и готовый адрес. */
  photo_key: string
  photo_url: string
  /** Опубликована. Черновик покупатель не видит. */
  is_published: boolean
  /**
   * Дата публикации, ISO 8601: её и показывает приложение. В будущем — новость
   * запланирована и появится сама. У черновика может быть null.
   */
  published_at: string | null
  created_at: string
  updated_at: string
}

export type NewsInput = Omit<NewsDto, 'id' | 'photo_url' | 'created_at' | 'updated_at'>

/** Новость в списке приложения — без текста: он нужен только на её экране. */
export interface PublicNewsItemDto {
  id: number
  title_ru: string
  title_uz: string
  lead_ru: string
  lead_uz: string
  photo_url: string
  published_at: string
}

/** Новость на её экране в приложении. */
export interface PublicNewsDto extends PublicNewsItemDto {
  body_ru: string
  body_uz: string
}

export interface NewsPage<T> {
  items: T[]
  total: number
}

export interface NewsMediaDto {
  key: string
  url: string
}

export const NEWS_TITLE_MAX = 120
export const NEWS_LEAD_MAX = 160
/** Предел хранимого HTML — как у страниц в настройках. */
export const NEWS_BODY_MAX = 100_000
export const NEWS_MEDIA_MAX_BYTES = 5 * 1024 * 1024
export const NEWS_PAGE_SIZE = 10
